import { Box, styled } from "@mui/material";

import spinner from "../assets/icons/spinner_bg.svg";
import spinnerTrack from "../assets/icons/spinner_track.svg";


const LoadingSpinner = styled("img")(() => ({
  position: "absolute",
  width: "32px",
  height: "32px",
  zIndex: 1,
  animation: "spin 2s linear infinite",
  transformOrigin: "left bottom",
  "@keyframes spin": {
    "0%": {
      transform: "translate(50%, -50%) rotate(0deg)",
    },
    "100%": {
      transform: "translate(50%, -50%) rotate(360deg)",
    },
  },
}));

export default function Loading() {
  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        mt: 2,
      }}
    >
      <img alt="spinner" src={spinner} />
      <LoadingSpinner alt="spinner-track" src={spinnerTrack} />
    </Box>
  );
}
